export default __webpack_public_path__ + "static/heartfulness-white-512-979422d5e250ed167adbcc974d5a23fa.png";